import { Routes, RouterModule } from '@angular/router';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import {LoginComponent} from "./auth/login/login.component";
import { PreloadAllModules } from '@angular/router';

const ROUTES: Routes = [
    // Antes da rota '' de proposito: e uma pagina publica e nao deve passar pelo
    // LayoutModule, que exige autenticacao (AuthorizationGuard / AuthorizationCanGuard).
    { path: 'cadastro-promotor', loadChildren: './cadastro-promotor/cadastro-promotor.module#CadastroPromotorModule' },
    { path: '', loadChildren: './layout/layout.module#LayoutModule' },
    { path: 'forbidden', component: ForbiddenComponent },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: 'entrar', component: LoginComponent }
];

export const AppRouting = RouterModule.forRoot(ROUTES, {
    useHash: true
});
